module.exports = __webpack_public_path__ + "static/media/MK_logo_no_bg.e8ebdcc9.svg";